module.exports = __webpack_public_path__ + "media/images/Tree_404-06f656da00e3b5f97e50bc8e98f323e9.jpg";